import React from 'react';
import PropTypes from 'prop-types';

function Title(props) {
  return <b>Candidate Portal</b>;
}

Title.defaultProps = {
  title: 'Candidate Portal',
};

Title.propTypes = {
  title: PropTypes.string,
};

export default Title;
